import {
  Camera, Wifi, Satellite, Cpu, Code2, ShieldCheck, Headset,
  Wrench, MapPin, Zap, Home, Store, Building2,
} from "lucide-react";

export const BRAND = {
  name: "SATCOM MEDIA TEKNOLOGI",
  short: "SATCOM",
  phone: "0877-7293-4344",
  waNumber: "6287772934344",
  website: "satcom.id",
  address:
    "Perumahan Graha Pasir Ona 2, Blok F1 No.24, RT.005/RW.010, East Rangkasbitung, Rangkasbitung, Lebak Regency, Banten 42313",
  area: "Rangkasbitung, Lebak & sekitarnya",
  mapsQuery: "Perumahan Graha Pasir Ona 2 Rangkasbitung Lebak Banten 42313",
};

export const WA_MSG_DEFAULT =
  "Halo SATCOM MEDIA TEKNOLOGI, saya ingin berkonsultasi mengenai kebutuhan teknologi saya.";

export const waLink = (msg) =>
  `https://wa.me/${BRAND.waNumber}?text=${encodeURIComponent(msg || WA_MSG_DEFAULT)}`;

export const telLink = `tel:+62${BRAND.phone.replace(/[^0-9]/g, "").replace(/^0/, "")}`;
export const mapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(BRAND.mapsQuery)}`;
export const mapsEmbed = `https://www.google.com/maps?q=${encodeURIComponent(BRAND.mapsQuery)}&output=embed`;

export const NAV = [
  { label: "Beranda", href: "#beranda" },
  { label: "Tentang Kami", href: "#tentang" },
  { label: "Layanan", href: "#layanan" },
  { label: "Produk", href: "#produk" },
  { label: "Solusi", href: "#solusi" },
  { label: "Galeri", href: "#galeri" },
  { label: "FAQ", href: "#faq" },
  { label: "Kontak", href: "#kontak" },
];

export const IMG = {
  hero:
    "https://static.prod-images.emergentagent.com/jobs/4d4418f7-8205-4aa0-a7c8-5fbdfdddb0a9/images/d7340ac3a6c4f23772cf7a461010e0603fd6c74959cca3b65650c9d2b2c4e359.jpeg",
  cctv:
    "https://images.unsplash.com/photo-1590613607026-15c463e30ca5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  parabola:
    "https://images.unsplash.com/photo-1615220843317-1e590f4155ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  wifi:
    "https://images.unsplash.com/photo-1750711158632-5273ec9b9b86?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hardware:
    "https://images.unsplash.com/photo-1515630278258-407f66498911?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  software:
    "https://images.unsplash.com/photo-1542831371-29b0f74f9713?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  network:
    "https://images.pexels.com/photos/6804586/pexels-photo-6804586.jpeg?auto=compress&cs=tinysrgb&w=1200",
  home:
    "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  store:
    "https://images.pexels.com/photos/1300402/pexels-photo-1300402.jpeg?auto=compress&cs=tinysrgb&w=1200",
  office:
    "https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const QUICK = [
  { icon: Camera, title: "CCTV & Keamanan", desc: "Instalasi sistem CCTV untuk rumah dan bisnis." },
  { icon: Wifi, title: "WiFi & Jaringan", desc: "Solusi konektivitas dan jaringan yang stabil." },
  { icon: Satellite, title: "Parabola & Satelit", desc: "Penjualan dan pemasangan perangkat parabola." },
  { icon: Cpu, title: "Hardware & Software", desc: "Perangkat dan kebutuhan teknologi komputer." },
];

export const SERVICES = [
  {
    no: "01", tag: "CCTV", icon: Camera, img: IMG.cctv,
    title: "Jual & Pasang CCTV",
    desc: "Solusi keamanan untuk rumah, toko, kantor, gudang, dan kebutuhan bisnis.",
    cta: "Konsultasikan Kebutuhan CCTV",
    wa: "Halo SATCOM, saya ingin konsultasi kebutuhan pemasangan CCTV.",
    span: "lg:col-span-7",
  },
  {
    no: "02", tag: "Parabola", icon: Satellite, img: IMG.parabola,
    title: "Parabola & Sistem Satelit",
    desc: "Penjualan, pemasangan, dan bantuan konfigurasi perangkat parabola.",
    cta: "Konsultasi Parabola",
    wa: "Halo SATCOM, saya ingin konsultasi kebutuhan parabola & satelit.",
    span: "lg:col-span-5",
  },
  {
    no: "03", tag: "WiFi", icon: Wifi, img: IMG.wifi,
    title: "WiFi & Jaringan",
    desc: "Solusi instalasi WiFi dan jaringan untuk rumah, kantor, maupun tempat usaha.",
    cta: "Konsultasi Jaringan",
    wa: "Halo SATCOM, saya ingin konsultasi kebutuhan WiFi & jaringan.",
    span: "lg:col-span-5",
  },
  {
    no: "04", tag: "Hardware", icon: Cpu, img: IMG.hardware,
    title: "Hardware Komputer",
    desc: "Kebutuhan perangkat keras komputer dan perangkat pendukung teknologi.",
    cta: "Konsultasi Hardware",
    wa: "Halo SATCOM, saya ingin menanyakan hardware komputer.",
    span: "lg:col-span-4",
  },
  {
    no: "05", tag: "Software", icon: Code2, img: IMG.software,
    title: "Software",
    desc: "Solusi software dan kebutuhan perangkat lunak sesuai kebutuhan pengguna.",
    cta: "Konsultasi Software",
    wa: "Halo SATCOM, saya ingin menanyakan kebutuhan software.",
    span: "lg:col-span-3",
  },
];

export const WHY = [
  { icon: Zap, title: "Solusi Terintegrasi", desc: "Produk dan layanan teknologi dalam satu tempat." },
  { icon: Headset, title: "Konsultasi Kebutuhan", desc: "Bantu menentukan solusi berdasarkan kebutuhan di lapangan." },
  { icon: Wrench, title: "Layanan Instalasi", desc: "Tidak hanya menjual produk, tetapi juga menyediakan pemasangan." },
  { icon: ShieldCheck, title: "Fokus pada Pelanggan", desc: "Solusi disesuaikan untuk rumah, toko, kantor, maupun bisnis." },
  { icon: MapPin, title: "Berbasis di Rangkasbitung", desc: "Melayani pelanggan di Lebak dan area sekitarnya." },
  { icon: Camera, title: "Respon Cepat", desc: "Tim mudah dihubungi via WhatsApp kapan saja." },
];

export const SOLUTIONS = [
  {
    key: "rumah", label: "Rumah", icon: Home, img: IMG.home,
    items: ["CCTV rumah", "WiFi", "Parabola", "Hardware"],
    cta: "Konsultasi untuk Rumah",
    wa: "Halo SATCOM, saya ingin konsultasi solusi teknologi untuk rumah.",
  },
  {
    key: "toko", label: "Toko & UMKM", icon: Store, img: "/gallery/pos-2.webp",
    items: ["CCTV", "WiFi", "Jaringan", "Hardware"],
    cta: "Konsultasi untuk Bisnis",
    wa: "Halo SATCOM, saya ingin konsultasi solusi teknologi untuk toko/UMKM.",
  },
  {
    key: "kantor", label: "Kantor", icon: Building2, img: IMG.office,
    items: ["CCTV", "Network", "WiFi", "Hardware & software"],
    cta: "Konsultasi untuk Kantor",
    wa: "Halo SATCOM, saya ingin konsultasi solusi teknologi untuk kantor.",
  },
];

export const PROCESS = [
  { no: "01", title: "Konsultasi", desc: "Ceritakan kebutuhan dan kondisi lokasi." },
  { no: "02", title: "Analisis Kebutuhan", desc: "Tentukan perangkat dan solusi yang sesuai." },
  { no: "03", title: "Penawaran", desc: "Berikan rekomendasi dan estimasi kebutuhan." },
  { no: "04", title: "Instalasi", desc: "Pemasangan dan konfigurasi sesuai solusi yang disepakati." },
];

export const GALLERY = [
  { src: "/gallery/cctv-install-1.webp", label: "Proses Instalasi CCTV" },
  { src: "/gallery/cctv-install-2.webp", label: "Pemasangan CCTV Outdoor" },
  { src: "/gallery/cctv-1.webp", label: "Kamera CCTV Terpasang" },
  { src: "/gallery/cctv-monitor-1.webp", label: "Monitoring CCTV" },
  { src: "/gallery/cctv-monitor-2.webp", label: "Live View CCTV" },
  { src: "/gallery/cctv-monitor-3.webp", label: "Hasil Rekaman CCTV" },
  { src: "/gallery/parabola-1.webp", label: "Instalasi Parabola" },
  { src: "/gallery/parabola-2.webp", label: "Pemasangan Parabola Digital" },
  { src: "/gallery/pos-1.webp", label: "Setup Perangkat Kasir (POS)" },
  { src: "/gallery/pos-2.webp", label: "Instalasi Sistem POS Toko" },
];

export const FAQS = [
  {
    q: "Apakah SATCOM MEDIA TEKNOLOGI melayani pemasangan CCTV?",
    a: "Ya, SATCOM MEDIA TEKNOLOGI menyediakan layanan jual dan pasang CCTV.",
  },
  {
    q: "Apakah bisa konsultasi sebelum membeli?",
    a: "Ya. Pelanggan dapat menghubungi SATCOM MEDIA TEKNOLOGI melalui WhatsApp untuk mendiskusikan kebutuhan.",
  },
  {
    q: "Apakah melayani pemasangan WiFi?",
    a: "SATCOM MEDIA TEKNOLOGI menyediakan layanan terkait WiFi dan jaringan.",
  },
  {
    q: "Apakah menjual hardware dan software?",
    a: "Ya, SATCOM MEDIA TEKNOLOGI menyediakan hardware dan software.",
  },
  {
    q: "Di mana lokasi SATCOM MEDIA TEKNOLOGI?",
    a: "SATCOM MEDIA TEKNOLOGI berlokasi di Perumahan Graha Pasir Ona 2, Rangkasbitung, Kabupaten Lebak, Banten.",
  },
];
